import { Section } from '@shared/components/Section';
import { ComPontos, Etapas } from '@shared/components/moldes';
import { BotaoDeContato } from '@inscricao/components/Contato';
import { curso } from '@curso/content/curso';
import { fasesDoCenario, sentidoDoDebriefing } from '@curso/content/etapas';
import { cenarios, convite } from '@curso/content/cenarios';
import atuarGrande from '@/assets/fases/atuar-grande.jpg';

/**
 * Bloco 7. Responde: o que eu vou fazer no sábado e no domingo.
 *
 * Nas páginas de curso que funcionam, a programação detalhada é sempre um
 * bloco próprio. É o que prova que o curso existe de verdade.
 *
 * Os seis títulos de cenário nomeiam a falha explorada, nunca o caso clínico.
 * Duas razões: a reunião de 14/10 pediu cautela para não entregar o escopo
 * completo de graça, e revelar o caso estraga a surpresa de quem vai atuar.
 */
/* Titulo comeca com o numero por extenso, como no texto da Kelly. */
const numeroPorExtenso: Record<number, string> = { 6: 'Seis' };

export function FimDeSemana() {
  return (
    <>
      <Section
        id="fim-de-semana"
        rotulo="O fim de semana"
        titulo={`${numeroPorExtenso[curso.cenarios] ?? curso.cenarios} cenários inspirados em situações reais`}
      >
        {/*
          A unica foto grande da pagina, e o unico lugar onde a tese aparece no
          tamanho que ela merece: a aviacao e a saude no mesmo quadro, dito sem
          texto. Nas outras abas a mesma familia de imagem aparece pequena, como
          apoio. Aqui ela e o argumento.
        */}
        <figure className="mb-9 overflow-hidden bg-tinta/10">
          <img
            src={atuarGrande}
            alt="Cockpit e sala de emergência lado a lado, as duas equipes trabalhando sob pressão."
            className="aspect-[21/9] w-full object-cover"
          />
        </figure>

        <p className="rotulo">
          <ComPontos
            texto={`${curso.horasPresenciais}\u00a0horas presenciais · pequenos grupos · aprendizagem pela experiência`}
          />
        </p>

        <p className="prosa mt-4">
          A maior parte da imersão acontece na prática. Os participantes vivenciam {curso.cenarios}&nbsp;cenários
          inspirados em situações reais da assistência à saúde, construídos para
          explorar desafios de comunicação, liderança, consciência situacional, suporte mútuo e
          tomada de decisão sob pressão.
        </p>

        <div className="mt-9">
          <p className="rotulo">Cada cenário, em três tempos</p>
          <div className="mt-4">
            <Etapas itens={fasesDoCenario} />
          </div>
        </div>

        <p className="prosa mt-8 text-tinta">{sentidoDoDebriefing}</p>
      </Section>

      <Section id="os-cenarios" rotulo="Os cenários" titulo="O que cada um explora">
        <Etapas itens={cenarios} />
        <p className="prosa mt-8 text-tinta">{convite}</p>

        <div className="mt-8 border-t border-linha pt-7">
          <p className="mb-4 text-apoio leading-relaxed text-tinta-suave">
            Deixe seu contato e receba o aviso quando as inscrições forem abertas.
          </p>
          <BotaoDeContato origem="fim-de-semana" />
        </div>
      </Section>
    </>
  );
}
